<template>
    <li class="bgr-white" v-if="show">
        <a class="favorites" :href="this.$root.fulldomain+'?favorites=1'">{{ fav }}</a>
    </li>
</template>

<script>
    import { EventBus } from '../../event-bus.js'
    export default {
        data () {
            return {
                show: false,
                fav: false,
            }
        },
        created: function () {
            EventBus.$on('setFavorites', this.getFavs)
            this.getFavs()
        },
        methods: {
            getFavs () {
                let f
                if (f = this.$ls.get('favorites')) {
                    this.$axios.get('/get/countfavorites?ids=' + f).then((res) => {
                        if (res.data) {
                            this.fav = res.data
                            this.show = true
                        } else {
                            this.show = false
                        }
                    })
                }
            },
        },
    }
</script>
